import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import type { DeleteSkill } from '../types/SharedActions';
import { updateLocalStorage } from './updateLocalStorage';

export const deleteSkill = (
  doc: CoverLetterDocumentType,
  value: DeleteSkill['value']
): void => {
  const skills = [...(doc.skills ?? [])];
  const skillsUpdated = skills.filter((_, index) => index !== value);

  updateLocalStorage(`skills`, skillsUpdated);
};
